import DOMPurify from 'dompurify';

export const PRODUCT_HTML_SAFE = {
  ALLOWED_TAGS: ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 'ul', 'ol', 'li', 'a', 'blockquote'],
  ALLOWED_ATTR: ['href', 'target', 'rel'],
};

export function sanitizeProductDescription(html) {
  if (!html || typeof html !== 'string') return '';
  const t = html.trim();
  if (!t) return '';
  return DOMPurify.sanitize(t, PRODUCT_HTML_SAFE);
}
